import { render, staticRenderFns } from "./beaconschecking.vue?vue&type=template&id=679e89b5&scoped=true"
import script from "./beaconschecking.vue?vue&type=script&lang=js"
export * from "./beaconschecking.vue?vue&type=script&lang=js"
import style0 from "./beaconschecking.vue?vue&type=style&index=0&id=679e89b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e89b5",
  null
  
)

export default component.exports